<template>
  <div
    class="rounded-xl backdrop-blur p-6 text-center
           hover:bg-cyan-400/10 hover:border-cyan-400 transition cursor-pointer"
    :class="active ? 'bg-white/30' : 'bg-white/10'"
  >
  
    <p :title="title" class="font-semibold overflow-hidden text-ellipsis">{{ title }}</p>
  </div>
</template>

<script setup>
defineProps({
  title: String,
  active: Boolean
})
</script>
